import { Box } from '@chakra-ui/react'
import { organizationListContext } from 'BrokerTsLib/src/context'
import type {
  OrganizationUnit,
  OrganizationUnitPagedQuery,
} from 'BrokerTsLib/src/dtos'
import { useGetAll } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useEffect, useState } from 'react'

import { ValidityBadge } from '@/components'

import { Pagination } from '../Pagination'
import {
  OrganizationListCityColumn,
  OrganizationListDescriptionColumn,
  OrganizationListNameColumn,
  OrganizationListTypeColumn,
  OrganizationListValidColumn,
  OrganizationsList,
} from './OrganizationList'
import { OrganizationListFilter } from './OrganizationListFilter'

const pageSize = 15
export const DependentOrganizationUnitList = ({
  organization,
}: {
  organization: OrganizationUnit
}) => {
  const [filter, setFilter] = useState<OrganizationUnitPagedQuery>({
    showInvalid: false,
    showRootOnly: false,
    pageIndex: 1,
    pageSize,
    superiorOrganizationUnitId: organization.id,
  })

  useEffect(() => {
    setFilter((value) => ({
      ...value,
      showInvalid: false,
      showRootOnly: false,
      pageIndex: 1,
      pageSize,
      superiorOrganizationUnitId: organization.id,
    }))
  }, [organization.id])
  const { data, refetch, isLoading } = useGetAll(filter)

  return (
    <Box>
      <organizationListContext.Provider
        value={{
          loading: isLoading,
          totalCount: data?.data.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize,
          filter,
          setCurrentPage: (p) => setFilter((f) => ({ ...f, pageIndex: p })),
          setPageSize: () => { },
          updateFilter: setFilter,
          reload: () => refetch(),
        }}
      >
        <OrganizationListFilter disableShowRootOnly p={4} />
        <OrganizationsList
          organizations={data?.data.items ?? []}
          columnsDefinition={[
            OrganizationListNameColumn,
            OrganizationListDescriptionColumn,
            OrganizationListCityColumn,
            OrganizationListTypeColumn,
            {
              ...OrganizationListValidColumn,
              cellExpr: (item) => (
                <ValidityBadge
                  valid={organization.effectivelyValid && item.valid}
                />
              ),
            },
          ]}
        />
        <Pagination context={organizationListContext} />
      </organizationListContext.Provider>
    </Box>
  )
}
